import { all } from 'redux-saga/effects';
import addCarEligibilitySaga from './addCarEligibilitySaga';
import addCarRegistrationInfoSaga from './addCarRegistrationInfoSaga';
import addCarUploadDocumentsSaga from './addCarUploadDocumentsSaga';
import removeCarSaga from './removeCarSaga';
import confirmTransferSaga from './confirmTransferSaga';
import addCarProcessSaga from './addCarProcessSaga';
import paymentSaga from './paymentSaga';
import billingAddressSaga from './billingAddressSaga';

export default function* rootSaga() {
  yield all([
    ...addCarEligibilitySaga,
    ...addCarRegistrationInfoSaga,
    ...addCarUploadDocumentsSaga,
    ...addCarProcessSaga,
    ...removeCarSaga,
    ...confirmTransferSaga,
    ...paymentSaga,
    ...billingAddressSaga,
  ]);
}
